import { CHAT_FOLDER_LIST_QUERY_KEY } from "@frontend-shared/constants";
import type { IUpdateChatFolderPayload } from "@frontend-shared/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { chatFolderApi } from "@/api/services";

export const useRenameChatFolder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: IUpdateChatFolderPayload) =>
      chatFolderApi.updateChatFolder(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CHAT_FOLDER_LIST_QUERY_KEY],
      });
    },
  });
};
